/**
 * Глобальный поиск. Модуль для работы с API.
 * @module search
 */

/**
 * Глобальный поиск
 * @param {Object} payload - {search}  Параметры поиска
 * @returns {Promise<Object>} - Результаты поиска
 * @throws {Error} - Ошибка при получении данных.
 */
export const globalSearch = async (payload, isAdmin = false) => {
  const params = new URLSearchParams();

  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        params.append(`${key}[]`, item);
      });
    } else {
      params.append(key, value);
    }
  });
 
  const queryString = params.toString();

  try {
    const response = await fetch(
      `/api/search${isAdmin ? "/admin" : ""}?${queryString}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`,
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
};
